import React, {useCallback} from 'react'

const TopUpAmount = ({selected = false, value = 0, onSelect = () => {}}) => {
    let style = selected ?  `select-topup-amount__balance--selected`  : ''

    return <div onClick={() => onSelect(value)} className={`select-topup-amount__balance ${style}`}>{value}</div> 
}

export default TopUpAmount